import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";
import styles from "../ProductStatusBox.module.scss";

export type GalleryButtonProps = {
  handleImageClick: () => void;
  image: string;
  title: string;
  useSmallImage?: boolean;
};

export const GalleryButton = ({
  handleImageClick,
  image,
  title,
  useSmallImage = false,
}: GalleryButtonProps) => {
  return (
    <button
      type="button"
      className={styles.mainImageButton}
      aria-label="main product image"
      data-testid="oos-layout:main-image:button"
      onClick={handleImageClick}
    >
      <img
        src={formatAmplienceImageURL(`${image}?$rsp-pdp-port-320$`)}
        alt={title}
        className={useSmallImage ? styles.mainImageSmall : styles.mainImage}
      />
    </button>
  );
};
